export const formatYear = (): number => new Date().getFullYear();
